import { useMutation } from "@apollo/client"
import { FC, useEffect } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { SAVE } from "../../../../../constants"
import { CommissionOverwriteDrawerProps } from "../../../../../interfaces"
import { COMMISSION_OVERWRITE_DRAWER_HEADING, CREATE, UPDATE } from "../../../../../utils/constant"
import { DrawerHeader, Sidedrawer } from "../../../../layout/Sidedrawer"
import { CREATE_COMMISSION_OVERWRITE, UPDATE_COMMISSION_OVERWRITE } from "../../gql"
import CommissionOverwriteForm from "./Form"

const CommissionOverwriteDrawer: FC<CommissionOverwriteDrawerProps> = ({ isOpen, toggle, recruiterDealId, isEdit, commissionOverwrite }) => {
  const { control, getValues, handleSubmit, reset, formState: { errors } } = useForm()

  useEffect(() => {
    if (isOpen && commissionOverwrite) {
      reset({
        type: commissionOverwrite?.type ? { value: commissionOverwrite.type.toUpperCase(), label: commissionOverwrite.type } : null,
        validDays: commissionOverwrite?.validDays ?? '',
        percentage: commissionOverwrite?.percentage?.replaceAll?.(' ', '') ?? '',
        note: commissionOverwrite?.note ?? '',
      })
    }
  }, [isOpen, commissionOverwrite, reset])

  const [createCommissionMutation, { loading }] = useMutation(CREATE_COMMISSION_OVERWRITE, {
    onCompleted: () => {
      toast.success("Commission Overwrite Added Successfully")
      toggle()
    },
    onError: () => toast.error("Unable To Add Commission Overwrite")
  })

  const [updateCommissionMutation, { loading: updating }] = useMutation(UPDATE_COMMISSION_OVERWRITE, {
    onCompleted: () => {
      toast.success("Commission Overwrite Updated Successfully")
      toggle()
    },
    onError: () => toast.error("Unable To Update Commission Overwrite")
  })

  const submitForm = async (values) => {
    const { type, validDays, percentage, note } = values
    const typeValue = type?.value
    const validDaysStr = typeof validDays === 'string' ? validDays.replace(/\s*days?\s*$/i, '').trim() : ''
    const percentageStr = typeof percentage === 'string' ? percentage.replace(/%/g, '').replace(/\s/g, '').trim() : ''
    const payload = {
      type: typeValue,
      validDays: validDaysStr || undefined,
      percentage: percentageStr || percentage,
      note: note ?? '',
    }
    if (isEdit) {
      await updateCommissionMutation({
        variables: {
          input: {
            id: commissionOverwrite?.id,
            ...payload,
          },
        },
      })
    } else {
      await createCommissionMutation({
        variables: {
          input: {
            recruiterDealId,
            ...payload,
          },
        },
      })
    }
  }

  return <Sidedrawer isOpen={isOpen} toggle={toggle}>
    <DrawerHeader
      buttonText={SAVE} disabled={loading || updating} loading={loading || updating} prevClick={toggle} heading={(isEdit ? UPDATE : CREATE) + COMMISSION_OVERWRITE_DRAWER_HEADING}
      nextClick={handleSubmit(submitForm)} />
    <CommissionOverwriteForm getValues={getValues} commissionOverwrite={commissionOverwrite} control={control} errors={errors} />
  </Sidedrawer>
}
export default CommissionOverwriteDrawer